import { defineMessages } from 'react-intl';
import { Modal } from '@alltrails/modal';
import { useFormatMessage } from '@alltrails/core/hooks/useFormatMessage';
import TextInput from '@alltrails/denali/components/TextInput';
import type { JSX } from 'react';

export type RenamePhotoModalProps = {
  isOpen: boolean;
  name: string;
  closeModal: () => void;
  onRenamePhotoSave: () => void;
  onRenamePhotoChange: (name: string) => void;
};

const messages = defineMessages({
  renamePhoto: { defaultMessage: 'Rename photo' },
  title: { defaultMessage: 'Title' },
  save: { defaultMessage: 'Save' }
});

const RenamePhotoModal = ({ isOpen, name, closeModal, onRenamePhotoSave, onRenamePhotoChange }: RenamePhotoModalProps): JSX.Element => {
  const {
    formattedDefaultMessages: { renamePhoto, title, save }
  } = useFormatMessage(messages);

  return (
    <Modal
      isOpen={isOpen}
      onCloseRequest={closeModal}
      title={renamePhoto}
      buttons={{
        primaryButton: {
          text: save,
          onClick: onRenamePhotoSave,
          testId: 'lightbox-rename-photo-save'
        }
      }}
    >
      <TextInput labelText={title} type="text" testId="lightbox-rename-photo_edit" value={name} onChange={onRenamePhotoChange} />
    </Modal>
  );
};

export default RenamePhotoModal;
